module.exports = __webpack_public_path__ + "static/media/condor_news.c99be371.png";